import clientBackend from "configurations/axios";
import {
  CLIENTES_ESTADO_FETCH_REQUEST,
  CLIENTES_ESTADO_FETCH_SUCCESS,
  CLIENTES_ESTADO_FETCH_FAILURE,
  CLIENTES_ESTADO_FETCH_RESET,
  CLIENTES_LIST_FETCH_REQUEST,
  CLIENTES_LIST_FETCH_SUCCESS,
  CLIENTES_LIST_FETCH_FAILURE,
  CLIENTES_LIST_FETCH_RESET,
} from "redux/types/clientesTypes";

const API_GET_CLIENTES_ESTADO = "/admin/clientes/estado/";
const API_GET_CLIENTES = "/admin/clientes/";

const getErrorMessage = (error, fallbackMessage) =>
  error?.response?.data?.message ||
  error?.response?.data?.apierror?.mensaje ||
  error?.response?.data ||
  error?.message ||
  fallbackMessage;

export const fetchEstadoClientes = (rucUsuario) => async (dispatch) => {
  dispatch({ type: CLIENTES_ESTADO_FETCH_REQUEST });

  try {
    if (!rucUsuario) {
      throw new Error("No se pudo determinar el RUC del usuario.");
    }

    const response = await clientBackend.get(`${API_GET_CLIENTES_ESTADO}${rucUsuario}`);

    dispatch({
      type: CLIENTES_ESTADO_FETCH_SUCCESS,
      payload: response.data,
    });

    return response.data;
  } catch (error) {
    const message = getErrorMessage(
      error,
      "No se pudo cargar el estado de clientes.",
    );

    dispatch({
      type: CLIENTES_ESTADO_FETCH_FAILURE,
      payload: message,
    });

    throw error;
  }
};

export const resetEstadoClientes = () => ({
  type: CLIENTES_ESTADO_FETCH_RESET,
});

export const fetchClientes = ({
  elementos = 15,
  page = 0,
  rucUsuario,
  sort = "estado,fechaRegistro,desc",
}) => async (dispatch) => {
  dispatch({ type: CLIENTES_LIST_FETCH_REQUEST });

  try {
    if (!rucUsuario) {
      throw new Error("No se pudo determinar el RUC del usuario.");
    }

    const queryParams = [
      `page=${page}`,
      `size=${elementos}`,
      sort ? `sort=${encodeURIComponent(sort)}` : null,
    ].filter(Boolean).join("&");
    const response = await clientBackend.get(
      `${API_GET_CLIENTES}${rucUsuario}?${queryParams}`,
    );

    dispatch({
      type: CLIENTES_LIST_FETCH_SUCCESS,
      payload: response.data,
    });

    return response.data;
  } catch (error) {
    const message = getErrorMessage(
      error,
      "No se pudo cargar el directorio de clientes.",
    );

    dispatch({
      type: CLIENTES_LIST_FETCH_FAILURE,
      payload: message,
    });

    throw error;
  }
};

export const resetClientes = () => ({
  type: CLIENTES_LIST_FETCH_RESET,
});
